/**
 * Simple slider with lory.
 * Supports arrow navigation, dragging, preloading, lazy initiate with in-view plugin
 *
 * It preloads next image on hover.
 *
 * With data-auto=true option, default 3000ms auto play is enabled.
 * Mouseover disables autoplay
 *
 * Usage:
 <div class="lory-slider lory-slider--relative" data-id="uniqueid">
   <div class="lory-frame">
     <div class="lory-slides">
       <div class="lory-slide lory-current">
         <img src="loaded.png" alt=""/>
       </div>
       <div class="lory-slide">
         <img data-src="to-preload.png" alt=""/>
       </div>
     </div>
   </div>
   <span class="arrow lory-prev"></span>
   <span class="arrow lory-next"></span>
 </div>
 *
 * @param element {Node|jQuery|undefined} - if no node/jquery is provided all
 * @param lazy {boolean|undefined}
 */
import { preloadUrl } from "../../vite/src/services/room-card-prefetcher";

App.namespace.wrap('es6.shared.lory_carousel', function (element, lazy, options, events = {}) {

  options = options || {};

  const DEFAULT_AUTOPLAY_DURATION = 3000;
  const PRELOAD_IN_STEP = options.infinite || options.preloadSlides || 2;

  function loadImage ($img) {
    $img.slice(0, PRELOAD_IN_STEP).each(function () {
      const src = $(this).data('src');
      if (src) {
        App.es6.shared.raf(() => $(this).attr('src', src));
      }
    });
  }

  function onBeforeSlide (event) {
    const $nextToLoad = $(event.target.querySelector('.lory-slide.active')).nextAll().slice(0, PRELOAD_IN_STEP + 1);
    const $prevToLoad = $(event.target).find('.lory-slide.active, .lory-slide.lory-current').prev();
    const $clonedLast = $(event.target).find('.lory-slide').slice(-2);

    $nextToLoad.add($prevToLoad).add($clonedLast).each(function () {
      loadImage($(this.querySelector('img')));
    });

    if (events.onBeforeSlide) {
      events.onBeforeSlide(event);
    }

    preloadRoomUrlOnSlide(event);
  }

  function preloadRoomUrlOnSlide(event) {
    preloadUrl(event.target.querySelector('a')?.href);
  }

  function mouseEnter() {
    this.removeEventListener('mouseenter', mouseEnter, false);
    loadImage($(this.querySelector('.lory-slide.lory-current, .lory-slide.current'))
      .nextAll()
      .slice(0, PRELOAD_IN_STEP)
      .find('img'))
  }

  //Initiate current slide image
  function onBeforeInit (event) {
    loadImage($(event.target).find('.lory-slide img'));
    event.target.addEventListener('mouseenter', mouseEnter, false);
  }

  function init(el, autoplay) {
    return function () {
      const lory = window.lory(el, Object.assign({
        infinite: 1,
        classNameFrame: 'lory-frame',
        classNameSlideContainer: 'lory-slides',
        classNamePrevCtrl: 'lory-prev',
        classNameNextCtrl: 'lory-next'
      }, options));

      if (autoplay) {
        window.setInterval(function () {
          if (el.parentElement.querySelector(':hover') !== el) {
            App.es6.shared.raf(lory.next);
          }
        }, DEFAULT_AUTOPLAY_DURATION);
      }

    }
  }

  function renderLazyDomImages(el) {
    const $slidesContainer = $(el).find('.lory-slides');

    const imagesList = $slidesContainer.data('images'); // jQ is parsing it into array
    if (imagesList) {
      const $firstSlide = $slidesContainer.find('.lory-slide').first();

      imagesList.forEach((image, index) => {
        if (index > 0) {
          var $slide = $firstSlide.clone()
            .removeClass('current')
            .removeClass('active');

          $slide.find('img')
            .attr('src', '')
            .attr('data-src', image)
            .attr('class', '')
            .attr('data-index', index)
            .attr('data-id', '')
            .attr('alt', '');

          $slidesContainer.append($slide);
        }
      });

      $slidesContainer.data('images', null);
      $slidesContainer.removeAttr('data-images', null);
    }
  }

  function initSlider (el) {
    renderLazyDomImages(el);

    const autoplay = el.attributes['data-auto'];
    const delay = (el.attributes['data-delay'] || { value: 0 }).value;

    el.addEventListener('before.lory.slide', onBeforeSlide);
    el.addEventListener('before.lory.init', onBeforeInit);

    if (delay) {
      window.setTimeout(init(el, autoplay), delay)
    } else {
      App.es6.shared.raf(init(el, autoplay))
    }
  }

  // immediate initialize single element
  if (element instanceof $) {
    if (lazy) {
      element.each(function () {
        inView(`.lory-slider[data-id='${$(this).data('id')}']`)
          .once('enter', initSlider);
      });
    } else {
      element.each(function () {
        initSlider(this);
      });
    }
  } else if (element) {
    if (lazy) {
      inView(`.lory-slider[data-id='${$(element).data('id')}']`)
        .once('enter', initSlider);
    } else {
      return initSlider(element);
    }
  } else {
    //lazy initiate

    //initiate if element is less than 1500px outside the viewport
    inView.offset(options.lazyOffset || -1500);

    //initiate in-view by unique id
    $('.lory-slider[data-id]').each(function () {
      inView(`.lory-slider[data-id='${$(this).data('id')}']`)
        .once('enter', initSlider);
    });
  }


});
